"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetProviderBranchesQuery = exports.useGetProvidersQuery = exports.useMatchProvidersQuery = exports.useGetSiteProviderQuery = exports.useDeleteSiteMutation = exports.useUpdateSiteMutation = exports.useCreateSiteMutation = exports.useGetDefaultSiteQuery = exports.useGetSiteBySlugQuery = exports.useGetSiteQuery = exports.useGetAllSitesQuery = exports.sitesApi = void 0;
// api/sitesApi.ts
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var API_URL = process.env.API_URL;
if (!API_URL) {
    throw new Error("API_URL environment variable is required");
}
// Static fallback query removed - using MongoDB exclusively
exports.sitesApi = (0, react_1.createApi)({
    reducerPath: "sitesApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(API_URL),
    tagTypes: ["sites"],
    endpoints: function (builder) { return ({
        getAllSites: builder.query({
            query: function () { return ({
                url: "/v1/sites",
                method: "GET",
            }); },
            providesTags: ["sites"],
        }),
        getSite: builder.query({
            query: function (siteId) { return ({
                url: "/v1/sites/".concat(siteId),
                method: "GET",
            }); },
            providesTags: function (result, error, siteId) { return [{ type: "sites", id: siteId }]; },
        }),
        getSiteBySlug: builder.query({
            query: function (slug) { return ({
                url: "/v1/sites/by-slug/".concat(slug),
                method: "GET",
            }); },
            providesTags: function (result, error, slug) { return [{ type: "sites", id: slug }]; },
        }),
        getDefaultSite: builder.query({
            query: function () { return ({
                url: "/v1/sites/default",
                method: "GET",
            }); },
        }),
        createSite: builder.mutation({
            query: function (siteConfig) { return ({
                url: "/v1/sites",
                method: "POST",
                body: siteConfig,
            }); },
            invalidatesTags: ["sites"],
        }),
        updateSite: builder.mutation({
            query: function (_a) {
                var siteId = _a.siteId, siteConfig = _a.siteConfig;
                return ({
                    url: "/v1/sites/".concat(siteId),
                    method: "PUT",
                    body: siteConfig,
                });
            },
            invalidatesTags: function (result, error, _a) {
                var siteId = _a.siteId;
                return [
                    "sites",
                    { type: "sites", id: siteId },
                ];
            },
        }),
        deleteSite: builder.mutation({
            query: function (siteId) { return ({
                url: "/v1/sites/".concat(siteId),
                method: "DELETE",
            }); },
            invalidatesTags: function (result, error, siteId) { return [
                "sites",
                { type: "sites", id: siteId },
            ]; },
        }),
        getSiteProvider: builder.query({
            query: function (siteId) { return ({
                url: "/v1/sites/".concat(siteId, "/provider"),
                method: "GET",
                headers: {
                    "x-use-firebase-token": "true",
                },
            }); },
        }),
        matchProviders: builder.query({
            query: function (siteName) { return ({
                url: "/v1/providers/match?siteName=".concat(encodeURIComponent(siteName)),
                method: "GET",
                headers: {
                    "x-use-firebase-token": "true",
                },
            }); },
        }),
        getProviders: builder.query({
            query: function () { return ({
                url: "/v1/providers/providers-list",
                method: "GET",
                headers: {
                    "x-use-firebase-token": "true",
                },
            }); },
        }),
        getProviderBranches: builder.query({
            query: function (providerId) { return ({
                url: "/v1/providers/".concat(providerId, "/branches"),
                method: "GET",
            }); },
        }),
    }); },
});
exports.useGetAllSitesQuery = exports.sitesApi.useGetAllSitesQuery, exports.useGetSiteQuery = exports.sitesApi.useGetSiteQuery, exports.useGetSiteBySlugQuery = exports.sitesApi.useGetSiteBySlugQuery, exports.useGetDefaultSiteQuery = exports.sitesApi.useGetDefaultSiteQuery, exports.useCreateSiteMutation = exports.sitesApi.useCreateSiteMutation, exports.useUpdateSiteMutation = exports.sitesApi.useUpdateSiteMutation, exports.useDeleteSiteMutation = exports.sitesApi.useDeleteSiteMutation, exports.useGetSiteProviderQuery = exports.sitesApi.useGetSiteProviderQuery, exports.useMatchProvidersQuery = exports.sitesApi.useMatchProvidersQuery, exports.useGetProvidersQuery = exports.sitesApi.useGetProvidersQuery, exports.useGetProviderBranchesQuery = exports.sitesApi.useGetProviderBranchesQuery;
